import React, { useEffect, useMemo, useState } from "react";

import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Dialog from "@mui/material/Dialog";
import { useForm, Controller } from "react-hook-form";
import Autocomplete from "@mui/material/Autocomplete";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { loadHearAbout } from "../../../_redux/actions/dataListActions";
import Button from "@mui/material/Button";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";
import Cookies from "universal-cookie";
import { LifeSafer } from "../../../_helpers/BrandConstants";
import {
  pickBackUpEnrollment,
  validateCode,
} from "../../../_redux/actions/enrolleeActions";
import { utilities ,langConversionHelper} from "@/_helpers";
import { useToaster } from "../../toaster/MuiToasterProvider";

const ReferralModal = ({
  loadHearAbout,
  // pickBackUpEnrollment,
  validateCode,
  referralModal,
  setReferralModal,
  goToNextStep,
  handleUpdate,
  pereferedContact,
  setActiveStep,
  handleReferalSubmit,
  hideLocationWelcome,
}) => {
  const { t,i18n } = useTranslation();
  const theme = useTheme();

  const [hearAboutLists, setHearAboutLists] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const showEnrollmentCodeSection = false;
  const cookies = new Cookies();
  const brand = cookies.get("lsEnrollmentReferral") || LifeSafer;
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const enrolleeUser = JSON.parse(sessionStorage.getItem("enrolleeUser"));
  const enrollmentCodeData = cookies.get("lsEnrollmentCode");
  const enrollNow = cookies.get("EnrollNow") || {};
  const {
    UTM_source,
    UTM_medium,
    UTM_campaign,
    GA_clientid,
    gclid,
    UserAgent,
    IPAddress,
    wbraid,
    gbraid,
    fbclid,
    fbp,
    ttclid,
    rdt_cid,
  } = enrollNow;
  const toast = useToaster();
  const jwtTokenData = cookies.get("lifesaferEnrollment");
  const sortedHearAboutLists = useMemo(
    () =>
      [...(hearAboutLists ?? [])].sort((a, b) =>
        (a?.description || "").localeCompare(b?.description || "", undefined, {
          sensitivity: "base",
        }),
      ),
    [hearAboutLists],
  );

  // const [selectedHearAboutId, setSelectedHearAboutId] = useState(null);

  let initialProfile = {
    Step: "Contact",
    FirstName: enrolleeUser?.FirstName,
    LastName: enrolleeUser?.LastName,
    HomePhone: enrolleeUser?.CellPhone,
    Email: enrolleeUser?.Email,
    contactPreference: pereferedContact || "Phone",
    BrandIdentifier: brand,
    // EnrollmentCodeId:
    //   zipCodeEnrollmentCodeId ||
    //   enrolleeUser?.enrollmentCodeId ||
    //   enrollmentCodeData?.enrollmentCodeId,
    CellPhone: enrolleeUser?.CellPhone,
    deviceType:
      enrolleeUser?.deviceType ||
      utilities?.deviceInfo(enrolleeUser?.clientTypeId || enrollNow?.DeviceType)
        ?.deviceType,
    EnrolleeId: enrolleeUser?.EnrolleeId,
    utM_source: UTM_source || null,
    utM_medium: UTM_medium || null,
    utM_campaign: UTM_campaign || null,
    gA_clientid: GA_clientid || null,
    zip: enrolleeUser?.zip || enrolleeUser?.zip || null,
    gclID: gclid || null,
    userAgent: UserAgent || null,
    ipAddress: IPAddress || null,
    wbraid: wbraid || null,
    gbraid: gbraid || null,
    fbclid: fbclid || null,
    fbp: fbp || null,
    ttclid: ttclid || null,
    rdt_cid: rdt_cid || null,
    story: enrolleeUser?.story || "Location",
  };

  useEffect(() => {
    if (enrolleeUser?.jwtToken || jwtTokenData?.jwtToken) {
      loadHearAbout()
        .then((x) => {
          setHearAboutLists(x);
        })
        .catch((e) => {
          console.error("i am error", e);
        });
    }
  }, [jwtTokenData?.jwtToken]);

  const {
    handleSubmit,
    control,
    setValue,
    register,
    formState: { errors },
    // watch,
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      Referral: "",
      HearAboutID: null,
      HearAboutName: null,
    },
  });

  useEffect(() => {
    if (!referralModal) {
      return;
    }

    const storedEnrolleeUser =
      JSON.parse(sessionStorage.getItem("enrolleeUser")) || enrolleeUser || {};
    const storedHearAboutId =
      storedEnrolleeUser?.HearAboutID || storedEnrolleeUser?.hearAboutID;
    const storedHearAboutName =
      storedEnrolleeUser?.HearAboutName || storedEnrolleeUser?.hearAboutName;

    if (storedHearAboutId && hearAboutLists?.length > 0) {
      const prefillData = hearAboutLists.find(
        (x) => String(x?.hearAboutID) === String(storedHearAboutId),
      );

      if (prefillData) {
        setValue("HearAboutID", prefillData);
      }
    }

    setValue("HearAboutName", storedHearAboutName || "");
  }, [referralModal, hearAboutLists, setValue]);

  const handleSkipReferral = () => {
    setReferralModal(false);
    const story = enrolleeUser?.story?.toLowerCase();

    // Location story decides between Vehicle and the PAM skip path.
    if (story === "location") {
      hideLocationWelcome?.();
      handleReferalSubmit();
      return;
    }

    // Other stories advance to the next step
    if (typeof goToNextStep === "function") {
      goToNextStep();
      return;
    }

    // Fallback: increment step if setter provided
    if (typeof setActiveStep === "function") {
      setActiveStep((prev) => (typeof prev === "number" ? prev + 1 : 1));
    }
  };

  const handleClose = () => {
    setReferralModal(false);
  };

  const onSubmit = async (data) => {
    if (submitting) {
      return;
    }
    setSubmitting(true);
    const referralValue = (data?.Referral || "").trim();
    const hearAboutNameValue = (data?.HearAboutName || "").trim();
    const hearAboutSelection = data?.HearAboutID || null;

    if (!referralValue && !hearAboutSelection && !hearAboutNameValue) {
      try {
        const storedEnrolleeUser =
          JSON.parse(sessionStorage.getItem("enrolleeUser")) || {};
        const cleanEnrolleeUser = { ...storedEnrolleeUser };

        delete cleanEnrolleeUser.HearAboutID;
        delete cleanEnrolleeUser.HearAboutName;
        delete cleanEnrolleeUser.hearAboutID;
        delete cleanEnrolleeUser.hearAboutName;

        sessionStorage.setItem(
          "enrolleeUser",
          JSON.stringify(cleanEnrolleeUser),
        );
        handleReferalSubmit();
        return;
      } finally {
        setSubmitting(false);
      }
    }

    try {
      if (referralValue) {
        try {
          // const enrollmentRes = await pickBackUpEnrollment(
          //   data?.Referral,
          //   brand,
          // );

          const enrollmentCode = await validateCode(referralValue, brand);

          cookies.set("lsEnrollmentCode", enrollmentCode, {
            path: "/",
            sameSite: "strict",
          });

          let updateData = {
            ...initialProfile,
            clientId: enrolleeUser?.clientId,
            story: enrolleeUser?.story || "Location",
            enrollmentCodeId: enrollmentCode?.enrollmentCodeId,
            isReferralModalSubmit: true,
          };
          await handleUpdate("Contact", updateData);
        } catch (e) {
          toast.error("Invalid enrollment code");
          setValue("Referral", "");
          setValue("HearAboutName", referralValue);

          const couponHearAbout = hearAboutLists?.find(
            (x) => x?.description === "Coupon/Brochure",
          );

          setValue("HearAboutID", couponHearAbout || null);
          // setIsHearAboutRequired(true);
          // setSelectedHearAboutId(couponHearAbout);
        }
      } else if (hearAboutSelection || hearAboutNameValue) {
        //   if (data?.HearAboutName?.length > 0) {
        //     try {
        //       const enrollmentCode = await validateCode(
        //         data?.HearAboutName,
        //         brand,
        //       );
        //       if (enrollmentCode) {
        //         cookies.set("lsEnrollmentCode", enrollmentCode, {
        //           path: "/",
        //           sameSite: "strict",
        //         });
        //       }
        //     } catch (e) {
        //       console.log(e);
        //     }
        //   }

        let updateData = {
          ...initialProfile,
          HearAboutID: hearAboutSelection?.hearAboutID || null,
          HearAboutName: hearAboutNameValue || null,
          clientId: enrolleeUser?.clientId,
          story: enrolleeUser?.story || "Location",
          enrollmentCodeId: enrollmentCodeData?.enrollmentCodeId,
          isReferralModalSubmit: true,
        };

        //   // setReferralModal(false);
        await handleUpdate("Contact", updateData);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setSubmitting(false);
    }

    // let updateData = {
    //   clientId: enrolleeUser?.clientId,
    //   story: "ISA Volunteer",
    //   enrollmentCodeId: enrollmentCodeData?.enrollmentCodeId,
    //   HearAboutID: couponHearAbout?.HearAboutID,
    //   HearAboutName: data?.HearAboutName,
    // };

    // handleUpdate("Referral", updateData);
  };

  return (
    <Dialog
      open={referralModal}
      disableEnforceFocus
      onClose={handleClose}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
      sx={{ display: "flex", justifyContent: "center" }}
      slotProps={{
        backdrop: {
          sx: {
            // backdropFilter: "blur(8px)",
            // backgroundColor: "#CCCCCC",
          },
        },
      }}
    >
      <DialogTitle
        sx={{
          // backgroundColor: `${brandColors[brand].secondary}`,
          fontWeight: "bold",
          color: "black",
          paddingBottom: "8px !important",
        }}
      >
        <Typography sx={{ fontWeight: "bold", marginTop: "9px" }}>
          {t("location.hearAboutHow")}
        </Typography>
      </DialogTitle>

      <DialogContent
        sx={{
          overflow: "auto",
        }}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          {showEnrollmentCodeSection && (
            <>
              <Grid sx={{ width: "100%", marginTop: "10px" }}>
                <TextField
                  style={{ width: "100%" }}
                  variant="outlined"
                  id="Referral"
                  size="small"
                  label={t("location.enrollmentCode")}
                  name="Referral"
                  placeholder=""
                  //   error={!!errors.referral}
                  disabled={submitting}
                  helperText={errors.Referral ? errors.Referral.message : ""}
                  {...register("Referral")}
                  slotProps={{ inputLabel: { shrink: true } }}
                />
                <Typography
                  sx={{
                    fontSize: "11.5px",
                    marginLeft: "12px",
                    color: "#7E7E7E",
                    marginTop: "4px",
                  }}
                >
                  {t("location.enterCode")}
                </Typography>
              </Grid>

              <Grid
                sx={{
                  display: "flex",
                  width: "100%",
                  alignItems: "center",
                  gap: "8px",
                  marginTop: "8px",
                  mb: "8px",
                }}
              >
                <Divider sx={{ width: "48%" }} />
                <Typography
                  sx={{
                    width: "2%",
                    fontSize: "12px",
                    mr: "6px",
                    color: "#DFDFDF",
                    fontWeight: "bold",
                  }}
                >
                  {t("location.or")}
                </Typography>
                <Divider sx={{ width: "46%" }} />
              </Grid>
            </>
          )}

          <Grid>
            <Typography sx={{ fontSize: "13px" }}>
              {t("location.hearAboutHowLong")}
            </Typography>
          </Grid>

          <Grid
            sx={{
              marginTop: "16px",
              display: "flex",
              flexDirection: "column",
              gap: "16px",
            }}
          >
            <Controller
              name="HearAboutID"
              // disableClearable
              render={({
                field: { onChange, value, ...fieldProps },
                fieldState: { error },
              }) => (
                <Autocomplete
                  {...fieldProps}
                  id="HearAboutID"
                  options={sortedHearAboutLists}
                  getOptionLabel={(option) =>
                    langConversionHelper.displayHearAboutLists(
                      option?.description,
                      i18n?.language
                    ) || ""
                  }
                  // getOptionLabel={(option) => option?.description}
                  isOptionEqualToValue={(option, value) =>
                    value?.hearAboutID === option?.hearAboutID
                  }
                  disabled={submitting}
                  onChange={(_, data) => {
                    onChange(data);
                    // setSelectedHearAboutId(data);
                  }}
                  value={value}
                  slotProps={{
                    clearIndicator: {
                      sx: { display: "none" },
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      fullWidth
                      {...params}
                      size="small"
                      label={t("location.hearAboutUs")}
                      variant="outlined"
                      placeholder={t("location.chooseOne")}
                      error={!!error}
                      helperText={error?.message}
                      slotProps={{ inputLabel: { shrink: true } }}
                    />
                  )}
                />
              )}
              control={control}
              // rules={{
              //   required: t("body.stateRequired"),
              // }}
            />

            <TextField
              style={{ width: "100%" }}
              variant="outlined"
              id="HearAboutName"
              size="small"
              label={t("location.whoReferred")}
              name="HearAboutName"
              placeholder={t("location.enterName")}
              error={!!errors.HearAboutName}
              disabled={submitting}
              helperText={
                errors.HearAboutName ? errors.HearAboutName.message : ""
              }
              {...register("HearAboutName", {
                required: false,
                // watch("Referral")?.length === 0 &&
                // selectedHearAboutId !== null
              })}
              slotProps={{
                input: {
                  sx: {
                    "& .MuiInputBase-input::placeholder": {
                      ...(isMobile && {
                        fontSize: "13px",
                      }),
                      opacity: 0.4,
                    },
                  },
                },
                inputLabel: {
                  shrink: true,
                },
              }}
            />
          </Grid>
          <Grid
            sx={{
              marginTop: "20px",
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: "16px",
              flexDirection: isMobile ? "column" : "row",
              mb: "4px",
            }}
          >
            <Button
              sx={{
                background: "#75BE43",
                color: "#305658",
                width: isMobile ? "100%" : "50%",
                fontWeight: "bold",
              }}
              type="submit"
              disabled={submitting}
            >
              {t("location.submit")}
            </Button>
            <Typography
              onClick={submitting ? undefined : handleSkipReferral}
              sx={{
                // width: "50%",
                width: isMobile ? "100%" : "50%",
                textAlign: "center",
                color: "#305658",
                fontSize: "12px",
                fontWeight: "600",
                cursor: submitting ? "default" : "pointer",
                pointerEvents: submitting ? "none" : "auto",
                opacity: submitting ? 0.6 : 1,
              }}
            >
              {t("location.skip")}
            </Typography>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

function mapStateToProps() {
  return {};
}

const mapDispatchToProps = {
  loadHearAbout,
  pickBackUpEnrollment,
  validateCode,
};

ReferralModal.propTypes = {
  loadHearAbout: PropTypes.func,
  pickBackUpEnrollment: PropTypes.func,
  validateCode: PropTypes.func,
  referralModal: PropTypes.bool,
  setReferralModal: PropTypes.func,
  goToNextStep: PropTypes.func,
  handleUpdate: PropTypes.func,
  pereferedContact: PropTypes.string,
  setActiveStep: PropTypes.func,
  handleReferalSubmit: PropTypes.func,
  hideLocationWelcome: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReferralModal);
